var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"al-notification_empty_state"},[_c('h5',[_vm._v("No "+_vm._s(_vm.name)+" yet")]),_c('p',{staticClass:"p"},[_vm._v(" When your team start working you "),_c('br'),_vm._v(" will see the "+_vm._s(_vm.name)+" here. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }